import { useState } from 'react';
import EventInfoCard from '../components/cards/v2/event-info.card';
import EventsContainer from '../components/containers/events.container';
import Header from '../components/header/default.header';
import InfoLayout from '../components/layouts/info.layout';
import MainLayout from '../components/layouts/v2/main.layout';
import AlternativeNavigation from '../components/navigation/alternative.navigation';
import HTab from '../components/navigation/tabs/htab';
import { EVENT_TAB_OPTIONS } from '../components/navigation/tabs/tab-options';
import { useInfoControl } from '../hooks/useInfoControl';
import { EventItem } from '../types/event.type';

export default function Events() {
  const [currentTab, setCurrentTab] = useState(EVENT_TAB_OPTIONS.THIS_WEEK);
  const [showInfo, current, trigger, reset] = useInfoControl<EventItem>();

  const CONTENT_COMPONENT_MAP = {
    [EVENT_TAB_OPTIONS.ALL]: () => (
      <EventsContainer trigger={trigger} query={['ALL']} />
    ),
    [EVENT_TAB_OPTIONS.COMING_SOON]: () => (
      <EventsContainer trigger={trigger} query={['COMING_SOON']} />
    ),
    [EVENT_TAB_OPTIONS.THIS_WEEK]: () => (
      <EventsContainer trigger={trigger} query={['THIS_WEEK']} />
    ),
    [EVENT_TAB_OPTIONS.THIS_MONTH]: () => (
      <EventsContainer trigger={trigger} query={['THIS_MONTH']} />
    ),
  };

  return (
    <MainLayout title="Events" layout="alt">
      <MainLayout.Header>
        <Header />
      </MainLayout.Header>
      <MainLayout.Content>
        <MainLayout.Navigation>
          <AlternativeNavigation />
        </MainLayout.Navigation>
        <MainLayout.Main>
          <InfoLayout close={reset} showInfo={showInfo}>
            <InfoLayout.Content>
              <HTab
                current={currentTab}
                set={setCurrentTab}
                tabOptions={EVENT_TAB_OPTIONS}
                tabContent={CONTENT_COMPONENT_MAP}
                tabControlClassName="mobile:py-4 tablet-lg:pb-5 mobile:px-2 tablet-lg:px-[40px] border-b border-dark-gray"
              />
            </InfoLayout.Content>
            <InfoLayout.Aside>
              {current && <EventInfoCard eventId={current.id} close={reset} />}
            </InfoLayout.Aside>
          </InfoLayout>
        </MainLayout.Main>
      </MainLayout.Content>
    </MainLayout>
  );
}
